"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_1 = __importDefault(require("@emotion/styled"));

var react_1 = __importDefault(require("react"));

var theme_1 = require("../../styles/theme");

var FlexContainer = styled_1["default"]('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: ", ";\n  flex-wrap: ", ";\n  ", " {\n    flex-direction: ", ";\n  }\n  justify-content: space-between;\n"], ["\n  display: flex;\n  flex-direction: ", ";\n  flex-wrap: ", ";\n  ", " {\n    flex-direction: ", ";\n  }\n  justify-content: space-between;\n"])), function (_a) {
  var reverse = _a.reverse,
      vertical = _a.vertical;
  return vertical ? reverse ? 'column-reverse' : 'column' : reverse ? 'row-reverse' : 'row';
}, function (props) {
  return props.wrap ? 'wrap' : 'nowrap';
}, theme_1.theme.breakpoints.tabletLandscapeDown, function (props) {
  return props.reverse ? 'column-reverse' : 'column';
});
var TwoColumnContainer = styled_1["default"](FlexContainer)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  > div {\n    width: ", ";\n  }\n  ", " {\n    > div {\n      width: 100%;\n    }\n  }\n"], ["\n  > div {\n    width: ", ";\n  }\n  ", " {\n    > div {\n      width: 100%;\n    }\n  }\n"])), function (_a) {
  var vertical = _a.vertical;
  return vertical ? '100%' : '48.5%';
}, theme_1.theme.breakpoints.tabletLandscapeDown);
var TwoColumnContainerWideLeft = styled_1["default"](FlexContainer)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  > div:first-of-type {\n    width: ", ";\n  }\n  > div:last-of-type {\n    width: ", ";\n  }\n  ", " {\n    > div:first-of-type, div:last-of-type {\n      width: 100%;\n    }\n  }\n"], ["\n  > div:first-of-type {\n    width: ", ";\n  }\n  > div:last-of-type {\n    width: ", ";\n  }\n  ", " {\n    > div:first-of-type, div:last-of-type {\n      width: 100%;\n    }\n  }\n"])), function (_a) {
  var vertical = _a.vertical;
  return vertical ? '100%' : '63.5%';
}, function (_a) {
  var vertical = _a.vertical;
  return vertical ? '100%' : '33.5%';
}, theme_1.theme.breakpoints.tabletLandscapeDown);
var TwoColumnContainerWideRight = styled_1["default"](FlexContainer)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  > div:first-of-type {\n    width: ", ";\n  }\n  > div:last-of-type {\n    width: ", ";\n  }\n  ", " {\n    > div:first-of-type, div:last-of-type {\n      width: 100%;\n    }\n  }\n"], ["\n  > div:first-of-type {\n    width: ", ";\n  }\n  > div:last-of-type {\n    width: ", ";\n  }\n  ", " {\n    > div:first-of-type, div:last-of-type {\n      width: 100%;\n    }\n  }\n"])), function (_a) {
  var vertical = _a.vertical;
  return vertical ? '100%' : '33.5%';
}, function (_a) {
  var vertical = _a.vertical;
  return vertical ? '100%' : '63.5%';
}, theme_1.theme.breakpoints.tabletLandscapeDown);
var ThreeColumnContainer = styled_1["default"](FlexContainer)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  > div {\n    width: ", ";\n  }\n  ", " {\n    > div {\n      width: 100%;\n    }\n  }\n"], ["\n  > div {\n    width: ", ";\n  }\n  ", " {\n    > div {\n      width: 100%;\n    }\n  }\n"])), function (_a) {
  var vertical = _a.vertical;
  return vertical ? '100%' : '30%';
}, theme_1.theme.breakpoints.tabletLandscapeDown);

exports.OneColumn = function (props) {
  return react_1["default"].createElement(FlexContainer, __assign({}, props));
};

exports.TwoColumn = function (props) {
  return react_1["default"].createElement(TwoColumnContainer, __assign({}, props));
};

exports.TwoColumnWideLeft = function (props) {
  return react_1["default"].createElement(TwoColumnContainerWideLeft, __assign({}, props));
};

exports.TwoColumnWideRight = function (props) {
  return react_1["default"].createElement(TwoColumnContainerWideRight, __assign({}, props));
};

exports.ThreeColumn = function (props) {
  return react_1["default"].createElement(ThreeColumnContainer, __assign({}, props));
};

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;